import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import 'semantic-ui-css/semantic.min.css';
import './index.css';
import 'react-table/react-table.css';
import 'react-toastify/dist/ReactToastify.css';

import packageJson from '../package.json';
import App from './App';
import { unregister } from './registerServiceWorker';
import { store } from './store/store';

global.appVersion = packageJson.version;

ReactDOM.render(
  <>
    <ToastContainer
      position='top-right'
      autoClose='10000'
      theme='light'
      closeOnClick
    />
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </>,
  document.getElementById('root')
);

unregister();
